import { useSectionEventOnViewportEntrance } from '@/hooks/useSectionEventOnViewportEntrance';
import React from 'react';
import { type Coverage, CoverageSection } from './Coverage';

export interface ElectricCoveragesProps {
  title: string;
  subtitle: string;
  data: Coverage[];
}

const ElectricCoverages: React.FC<ElectricCoveragesProps> = ({ title, subtitle, data }) => {
  const intersectionRef = useSectionEventOnViewportEntrance({
    sectionName: 'electricCoverages',
    page: 'car',
  });

  return <CoverageSection title={title} subtitle={subtitle} coverages={data} ref={intersectionRef} />;
};

export default React.memo(ElectricCoverages);
